// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__jK8fC","amount":"Amount_amount__1mlrj","tip":"Amount_tip__1BpEY","tipHeader":"Amount_tipHeader__1WL_v","tipsWrap":"Amount_tipsWrap__I4cu5"};